














import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GRadioButton',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    value: {
      type: Number as PropType<number>,
      required: true,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isFrame: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    onChange(e: Event): void {
      if (e.target instanceof HTMLInputElement) {
        this.$emit('change', Number(e.target.value));
      }
    },
  },
});

